import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { Request } from "src/app/parametrage/core/model/request";

@Component({
  selector: "app-request-tab",
  templateUrl: "./request-tab.component.html",
  styleUrls: ["./request-tab.component.scss"],
})
export class RequestTabComponent implements OnInit {
  requests: Request[];
  codeClient: String;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _requestService: RequestService
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.codeClient = params["codeClient"];
      this.getRequestsByCodeClient(this.codeClient);
    });
  }

  getRequestsByCodeClient(codeclient) {
    this._requestService.getRequestsByCodeClient(codeclient).subscribe(
      (data) => {
        this.requests = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
